<template>
  <b-card header="Параметры">
    <b-card sub-title="Период отчета">
      <date-picker v-model="dateFromC" :config="optionsDateFrom"></date-picker>
      <date-picker v-model="dateToC" :config="optionsDateTill"></date-picker>
    </b-card>
    <br>
    <b-card sub-title="Лен. область">
      <b-form-group label="Выберите район">
        <template slot="label">
          <b-form-checkbox
            v-model="allSelected"
            @change="toggleAll"
            :indeterminate="indeterminate"
            aria-describedby="region_sel"
            aria-controls="region_sel"
          >
            {{ allSelected ? 'Очистить' : 'Выбрать все' }}
          </b-form-checkbox>
        </template>
        <b-form-checkbox-group id="region_sel" align="left" stacked v-model="region_sel" name="reg_sel"
                               :options="options_sel">
        </b-form-checkbox-group>
      </b-form-group>
    </b-card>
    <br>
    <button type="button" class="btn btn-primary"
    v-on:click="update_data">Обновить
    </button>
    <div>
    <b-modal v-model="modalShowRegSel" centered ok-only title="Внимание" >
      Выберите район
    </b-modal>
  </div>
  </b-card>
</template>

<script>
// import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
export default {
  name: 'ParamBox',
  props: ['options_sel', 'dateTo', 'dateFrom'],
  // components: {
  //  datePicker
  // },
  data () {
    return {
      dateFromC: new Date().toLocaleDateString('ru-RU').substr(0, 10),
      dateToC: new Date().toLocaleDateString('ru-RU').substr(0, 10),
      modalShowRegSel: false,
      optionsDateFrom: {
        format: 'DD.MM.YYYY',
        useCurrent: true,
        maxDate: this.dateToC
      },
      optionsDateTill: {
        format: 'DD.MM.YYYY',
        useCurrent: true,
        minDate: this.dateFromC
      },
      allSelected: true,
      indeterminate: false,
      region_sel: []
    }
  },
  created () {
    //
  },
  mounted () {
    if (localStorage.getItem('dateFrom')) {
      this.dateFromC = localStorage.getItem('dateFrom')
    } else {
      this.dateFromC = new Date().toLocaleDateString('ru-RU').substr(0, 10)
    }
    if (localStorage.getItem('dateTo')) {
      this.dateToC = localStorage.getItem('dateTo')
    } else {
      this.dateFromC = new Date().toLocaleDateString('ru-RU').substr(0, 10)
    }
    if (localStorage.getItem('option_reg')) {
      this.options_sel = JSON.parse(localStorage.getItem('option_reg'))
    }
    if (localStorage.getItem('regs_id')) {
      this.region_sel = JSON.parse(localStorage.getItem('regs_id'))
    } else {
      this.toggleAll(this.allSelected)
    }
    this.optionsDateTill.maxDate = new Date()
    this.updateCalendar()
  },
  watch: {
    region_sel (newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      localStorage.setItem('regs_id', JSON.stringify(this.region_sel))
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.options_sel.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
    dateFrom (newVal, oldVal) {
      this.dateFromC = newVal
    },
    dateFromC (newVal, oldVal) {
      this.optionsDateTill.minDate = newVal
      localStorage.setItem('dateFrom', newVal)
    },
    dateTo (newVal, oldVal) {
      this.dateToC = newVal
    },
    dateToC (newVal, oldVal) {
      this.optionsDateFrom.maxDate = newVal
      localStorage.setItem('dateTo', newVal)
    }
  },
  methods: {
    updateCalendar () {
      this.optionsDateFrom.maxDate = this.dateToC
      // .getDate()
      // this.optionsDateTill.maxDate = this.dateCurrent.getDate()
      this.optionsDateTill.minDate = this.dateFromC
      // .getDate()
    },
    toggleAll (checked) {
      this.region_sel = checked ? [].map.call(this.options_sel, (obj) => { return obj.value }) : []
    },
    update_data: function () {
      if (this.region_sel.length > 0) {
        this.$emit('update-data', [this.dateFromC, this.dateToC, this.region_sel])
      } else {
        this.modalShowRegSel = true
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ParamBox.vue